import { defineStore } from "pinia";

export const useRouteBlockerStore = defineStore("routeBlockerStore", {
  state: () => ({
    displayMessage: { route: null, message: null, onSave: null },
    passThrough: false,
  }),
  actions: {
    setDisplayMessage(display) {
      this.displayMessage = display;
    },
    setPassThrough(value) {
      this.passThrough = value;
    },
    clearDisplayMessage() {
      this.displayMessage = { route: null, message: null, onSave: null };
    },
  },
});
